// @flow

import React from 'react';
import type { Node } from 'react';
import { Section, Wrapper } from '@riseart/layout';
import {
  gridSectionCls,
  GridCounter,
  GridLayoutSwitch,
  GridSortSelect,
  GridHeader,
} from '@riseart/grid';
import { IsomorphicRipple } from 'shared_components/common/preloader/IsomorphicRipple';
import { InfinitePaginationCounter } from 'shared_components/common/pagination/counter/Infinite';

type Props = {
  layoutSwitch?: Node,
  sortOptions: Object,
  sortListener: any,
  layoutOptions: Object,
  layoutListener: any,
  pagination: Object,
  isLoading: boolean,
  hideSort: boolean,
  children: React$Element<*>,
};

// Shop grid preloader configuration
const SHOP_GRID_RIPPLE_CONFIG = {
  small: { backgroundPositionY: 118 },
  medium: { backgroundPositionY: 118 },
  large: { backgroundPositionY: 118 },
};

/**
 * ArtListSection
 *
 * @param {Props} props
 */
export const ArtListSection = ({
  layoutSwitch = null,
  sortOptions,
  sortListener,
  layoutOptions,
  layoutListener,
  pagination,
  isLoading,
  children,
  hideSort,
}: Props): Node => (
  <IsomorphicRipple isActive={isLoading} styleConfig={SHOP_GRID_RIPPLE_CONFIG}>
    <Section className={gridSectionCls}>
      <Wrapper>
        <GridHeader>
          {!hideSort ? (
            <GridSortSelect
              label={sortOptions.label}
              onChange={sortListener}
              options={sortOptions.options}
            />
          ) : (
            <span />
          )}
          <div>
            <GridCounter>
              <InfinitePaginationCounter totalItems={(pagination && pagination.totalItems) || 0} />
            </GridCounter>
            {layoutSwitch || <GridLayoutSwitch options={layoutOptions} onClick={layoutListener} />}
          </div>
        </GridHeader>
        {children}
      </Wrapper>
    </Section>
  </IsomorphicRipple>
);
